import { NAME } from './constants';

export const FETCH = `${NAME}/FETCH`;
export const TOGGLE = `${NAME}/TOGGLE`;
export const OPTION_CHANGE = `${NAME}/OPTION_CHANGE`;
export const TEMPLATE_CHANGE = `${NAME}/TEMPLATE_CHANGE`;
export const NORMALIZE = `${NAME}/NORMALIZE`;
